import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid2x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDotGrid2x3"><Path d="M9.25 12H9.75M14.25 12H14.75M9.25 5.5H9.75M14.25 5.5H14.75M9.25 18.5H9.75M14.25 18.5H14.75M10.5 11H8.5V13H10.5V11ZM15.5 11H13.5V13H15.5V11ZM10.5 4.5H8.5V6.5H10.5V4.5ZM15.5 4.5H13.5V6.5H15.5V4.5ZM10.5 17.5H8.5V19.5H10.5V17.5ZM15.5 17.5H13.5V19.5H15.5V17.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDotGrid2x3;
